<template>
  <w-icon-wrapper icon-name='work-help-icon'>
    <g
      id='Pfad_55650'
      data-name='Pfad 55650'
      fill='none'
    >
      <path
        d='M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z'
        stroke='none'
      />
      <path
        d='M 12 0 C 18.62699890136719 0 24 5.37299919128418 24 12 C 24 18.62699890136719 18.62699890136719 24 12 24 C 5.37299919128418 24 0 18.62699890136719 0 12 C 0 5.37299919128418 5.37299919128418 0 12 0 Z M 12 22 C 17.51399993896484 22 22 17.51399993896484 22 12 C 22 6.486000061035156 17.51399993896484 2 12 2 C 6.486000061035156 2 2 6.486000061035156 2 12 C 2 17.51399993896484 6.486000061035156 22 12 22 Z'
        fill='currentColor'
        stroke='none'
      />
    </g>
    <g
      id='Gruppe_25426'
      data-name='Gruppe 25426'
      transform='translate(0 1)'
    >
      <g
        id='Pfad_55651'
        data-name='Pfad 55651'
        fill='none'
      >
        <path
          d='M12,4A4,4,0,0,0,8,8h2a2,2,0,1,1,2,2H11v5h2V11.874A4,4,0,0,0,12,4Z'
          stroke='none'
        />
        <path
          d='M 12 4 C 14.20600032806396 4 16 5.793999671936035 16 8 C 16 9.859999656677246 14.72399997711182 11.42799949645996 13 11.87400054931641 L 13 15 L 11 15 L 11 10 L 12 10 C 13.10299968719482 10 14 9.102999687194824 14 8 C 14 6.897000312805176 13.10299968719482 6 12 6 C 10.89700031280518 6 10 6.897000312805176 10 8 L 8 8 C 8 5.793999671936035 9.793999671936035 4 12 4 Z'
          fill='currentColor'
          stroke='none'
        />
      </g>
      <g
        id='Ellipse_1509'
        data-name='Ellipse 1509'
        fill='none'
        stroke='currentColor'
        stroke-width='2'
        transform='translate(10.5 16)'
      >
        <circle
          cx='1.5'
          cy='1.5'
          r='1.5'
          stroke='none'
        />
        <circle
          cx='1.5'
          cy='1.5'
          fill='none'
          r='0.5'
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconHelp' };
</script>
